export default __webpack_public_path__ + "static/media/banner7.6c929808.svg";